<template>
  <el-form-item
    :class="{ desktop: isDesktop }"
    label-width="150px"
    label="Language"
  >
    <el-select
      v-model="value"
      multiple
      placeholder="All"
      @update:modelValue="updated"
    >
      <el-option
        v-for="item in options"
        :key="item.key"
        :label="item.label"
        :value="item.key"
      />
    </el-select>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import {
  DeviceLanguage,
  DeviceLanguageLabel,
  DeviceLanguageLabels
} from '@/api/types'
import useResize from '@/hooks/useResize'

type DeviceLanguageEntry = {
  key: DeviceLanguage
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'DeviceLanguageSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = DeviceLanguageLabels.map<DeviceLanguageEntry>(
      (languageLabel: DeviceLanguageLabel) => {
        return {
          key: languageLabel.type_id,
          label: languageLabel.label,
          disabled: false
        }
      }
    )

    const { isDesktop } = useResize()

    const updated = (newValue: Array<DeviceLanguage>) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { options, updated, isDesktop, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

.desktop .el-select {
  width: 400px;
}
</style>
